'use client';

import ClosedCampaignPopup from './ClosedCampaignPopup';

const ClosedOfferingPopup = ({ offeringData }) => {
  const isClosed = offeringData?.status === 'closed';
  const isOwnPage = offeringData?.slug === 'startengine';

  if (!isClosed || isOwnPage) return null;

  return <ClosedCampaignPopup />;
};

export default ClosedOfferingPopup;
